import { render, staticRenderFns } from "./UnionEdit.vue?vue&type=template&id=21942e6a&scoped=true"
import script from "./UnionEdit.vue?vue&type=script&lang=js"
export * from "./UnionEdit.vue?vue&type=script&lang=js"
import style0 from "./UnionEdit.vue?vue&type=style&index=0&id=21942e6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21942e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21942e6a')) {
      api.createRecord('21942e6a', component.options)
    } else {
      api.reload('21942e6a', component.options)
    }
    module.hot.accept("./UnionEdit.vue?vue&type=template&id=21942e6a&scoped=true", function () {
      api.rerender('21942e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionEdit.vue"
export default component.exports